<template lang="html">
  <div class="eachendcompiler">
    <div
      class="eachendcompiler--header"
      v-show="isShowReel && isShowOverlay && !isPythonOnline"
    >
      <QuestionMenu
        class="eachendcompiler--header-questionmenu"
        :class="{
          'eachendcompiler--header-questionmenu-problemSolved': isShowProblemSolved,
        }"
        role="student"
        :bundle="params.bundle"
        :current="index"
        :needLock="isNeedLock"
        :needCorrect="isNeedCorrect"
        @selectIndex="selectIndex"
        @modify-title="modifyTitle"
      />

      <!-- <p v-show='isShowTipText' class='eachendcompiler--tipText'>请务必登录学而思客户端监考，否则将取消考试成绩</p> -->
    </div>
    <QuestionToast
      v-if="isShowReel"
      :bundleList="params.bundle"
      :propCurrentIndex="index"
      @selectIndex="selectIndex"
    />
    <MainCompiler
      class="eachendcompiler--main"
      v-show="params.bundle[0].category !== -1"
      :params="params"
      :index="index"
      :isCmLast.sync="isCmLast"
      :allowEnterAgain="allowEnterAgain"
      :everUnPublished="everUnPublished"
      @compilerLoaded="handleLoaded"
      @updateBundle="handleUpdate"
      @choiceEnsure="handleChoiceEnsure"
      @choiceFinish="handleChoiceFinish"
      @cppPageStatus="handleCppPage"
      @cppFinish="handleCppFinish"
      @cmReport="handleCmReport"
      @cmFinish="handleCmFinish"
      @cmRetry="handleCmRetry"
      @paperQuestionNext="handlePaperNext"
      @paperQuestionEnsure="handlePaperEnsure"
    />
    <Button
      type="text"
      :class="genBackCSS()"
      v-show="isShowOverlay && !isPythonOnline"
      @click="handleBack"
    >
      返回
    </Button>
    <!-- <Button
      type="text"
      v-if="isNeedSubmit"
      :class="genHandCSS()"
      v-show="isShowOverlay && params.bundle.length - 1 === index"
      @click="handleSubmit"
    >
      交卷
    </Button> -->
    <div class="eachendcompiler--mask" v-if="isNeedDialog">
      <div class="eachendcompiler--dialog">
        <i class="eachendcompiler--dialog-icon"></i>
        <div class="eachendcompiler--dialog-txt">
          <h3>{{ modal.title }}</h3>
          <h5>{{ modal.label }}</h5>
        </div>
        <div class="eachendcompiler--dialog-btn" @click="handleDirectBack">
          {{ modal.btnLabel }}
        </div>
      </div>
    </div>
    <div class="eachendcompiler--mask" v-if="isNeedPre"></div>

    <Houboshi
      v-if="hbsDataloaded && !isPythonOnline"
      ref="hbs"
      class="houboshi"
      :role="1"
      :token="token"
      :hbsParams="hbsParams"
      :isShowTools="false"
      :loginType="loginType"
    ></Houboshi>

    <Dialog :visible="isShowDialog" :defaultClazz="false">
      <div>
        <img width="413" height="358" src="~@/assets/challenge_completed.png" />
      </div>
      <div slot="footer">
        <Button
          size="mini"
          class="eachendcompiler--dialog-button"
          @click="handleBack"
        >
          完成
        </Button>
      </div>
    </Dialog>
    <!-- <CountDown
      class="eachendcompiler--countDown"
      v-show="isCountDown"
      :tipText="countDownText"
      :isClear="isClearTimer"
      dayTxt="天"
      :timeDistance="params.countDownTime"
    /> -->
    <HandInPaper
      v-show="isCountDown"
      :isNeedSubmit="isNeedSubmit"
      :newSubmitBtn="newSubmitBtn"
      :tipText="countDownText"
      :timingFlag="params.timingFlag"
      :isClear="isClearTimer"
      :timeDistance="params.countDownTime"
      @handleSubmit="handleSubmit"
    />
    <!-- <CountDown 
      v-if='params.timingType && !isNeedDialog && abc!== -1'
      :publishTime="params.firstOpenTime"
      :keepTime='params.countDownTime'
      class='eachendcompiler--countDown' 
    /> -->

    <!-- <AfterClassSubBtn
      v-if="isNeedSubmit"
      v-show="isShowOverlay"
      :isDragging.sync='isDragging'
      @handleClick="handleSubmit"
    /> -->
    <!-- 防止拖动时卡顿添加遮罩 -->
    <!-- 交卷弹窗 -->
    <div
      v-if="isDragging && isShowOverlay"
      class="eachendcompiler--drag-mask"
    ></div>
    <!-- <div
      class="eachendcompiler--mask hand"
      v-if="isHandDialog"
    >
      <div class="eachendcompiler--dialog">
        <div class='header'>提示</div>
        <i class="eachendcompiler--dialog-icon"></i>
        <div class="eachendcompiler--dialog-txt">
          <h5>提交后本部分题目将无法修改，确定提交全部题目吗？</h5>
        </div>
        <div class='hand_btn'>
            <div
            class="eachendcompiler--dialog-btn back"
            @click="handleHandBack"
          >返回</div>
          <div
            v-if='isHandSubmit'
            class="eachendcompiler--dialog-btn submit"
            @click="handleHandSubmit"
          >提交</div>
          <div
            v-else
            class="eachendcompiler--dialog-btn down_count"
          >{{count}}s</div>
          </div>
      </div>
    </div> -->
    <modify-sa-title
      ref="modifysa"
      :current-exercise.sync="params.bundle[index]"
    />
    <answerConfirm
      :visible.sync="isHandDialog"
      :bundleList="params.bundle"
      :totalScore="params.totalScore"
      :isActiveSubmission="isActiveSubmission"
      @handleHandSubmit="handleHandSubmit"
      @handleBack="handleBack"
    />
    <Button
      type="text"
      class="eachendcompiler--problemSolved"
      v-show="isShowProblemSolved"
      @click="showProblemSolved"
    >
      查看题解
    </Button>
    <ProblemSolved
      :visible.sync="isShowProblemSolvedDialog"
      :index="index"
      :bundleList="params.bundle"
    />
    <DiagnosisDialog
      v-if="isShowDiagnosisDialog"
      :status.sync="diagnosisDialogStatus"
      :bundleId="params.bundleId"
      :moduleId="params.moduleId"
      @handleBack="handleBack"
    />
  </div>
</template>

<script type="text/babel">
import { mapState, mapGetters } from 'vuex';
import 'katex/dist/katex.min.css';
import '../../assets/styles/katex.custom.css';
import {
  getSubject,
  updateBundle,
  updateStudentAnswer,
  getCompetitionStatus,
  updatePaperAnswer,
  saveProject,
  recordStartAnswerTime,
  recordSubmitTime,
} from '@/services/student';
import { saveCMUrl } from '@/services/teacher.js';
// import loading from '@/utils/loading';
import Dialog from '@/components/Dialog.vue';
import Button from '@/components/Button.vue';
// import CountDown from '@/components/CountDown1.vue';
import HandInPaper from '@/components/HandInPaper.vue';

import XEventSource from '@/utils/x-eventsource';
import QuestionMenu from '@/components/QuestionMenu.vue';
import MainCompiler from '@/components/MainCompiler.vue';
import ModifySaTitle from '@/components/modifySaTitle.vue';
import QuestionToast from '@/components/QuestionToast.vue';
import { flatMapDeep } from 'lodash';
import { errorHandler } from '@/utils/errorHandler';
import { xesView, generateEditorPub } from '@/plugins/xes-analytice';
import answerConfirm from '@/components/answerConfirm.vue';
import ProblemSolved from '@/components/ProblemSolved.vue';
import DiagnosisDialog from '@/components/diagnosisDialog.vue';
import { submitDiagnosis } from '@/services/diagnosis';

export default {
  name: 'StudentCompiler',
  components: {
    Button,
    Dialog,
    QuestionMenu,
    MainCompiler,
    // CountDown,
    ModifySaTitle,
    QuestionToast,
    answerConfirm,
    ProblemSolved,
    DiagnosisDialog,
    HandInPaper,
  },

  data() {
    return {
      params: {
        bundle: [
          {
            category: -1,
          },
        ],
      },
      index: 0,
      isShowOverlay: false,

      // 弹窗相关
      isNeedDialog: false,
      modal: {
        title: '',
        label: '',
        btnLabel: '',
      },

      isShowDialog: false,

      // 题组展示相关
      isShowReel: true,
      isNeedLock: false,
      isNeedCorrect: false,

      // 特殊遮罩
      isNeedPre: false,

      // 猴博士相关
      hbsParams: {},
      hbsDataloaded: false,
      // 是不是Python在线
      isPythonOnline: false,
      isCmLast: false,
      // 提交按钮
      isNeedSubmit: true,
      isDragging: false,
      count: 5,
      isHandSubmit: false,
      timer: null,
      handBtnText: '',
      isHandDialog: false,
      isClearTimer: false,
      cppCategoryList: [4, 9],
      notShowHBSCtype: [13],
      isActiveSubmission: false,
      isAlreadySubmit: false,
      isShowProblemSolvedDialog: false,

      // 进入编辑器时间（埋点使用）
      enterTime: Date.now(),
      submited: false,
      everUnPublished: false,
      allowEnterAgain: 0,
      isShowDiagnosisDialog: false,
      diagnosisDialogStatus: 0,

      // sse
      xeventsource: null,
      sseReconnectTimer: null, // sse重连定时器
    };
  },

  computed: {
    ...mapState({
      competitionId: (state) => state.router.id,
      loginType: (state) => state.router.loginType,
      isSerial: (state) => state.router.isSerial,
      compType: (state) => state.router.compType,
    }),
    ...mapGetters(['tokenKey', 'xilieTokenKey']),
    current() {
      return this.index + 1;
    },

    token() {
      return this.params.token;
    },
    // handBtnText(){
    //   let text = this.count === 1? '提交' : this.count+'s'
    //   return text
    // }
    isShowTipText() {
      return [1, 5, 6].includes(this.params.bundle[this.index].category);
    },
    countDownText() {
      return this.params.timingFlag === 0 ? '距离收题:' : '答题时间还剩:';
    },
    isCountDown() {
      // 二次进入不显示倒讲时
      // console.log('this.everUnPublished,this.allowEnterAgain', this.everUnPublished, this.allowEnterAgain)
      if (this.everUnPublished && this.allowEnterAgain === 1) {
        return false;
      }
      return !this.isNeedDialog &&
        this.params.timingFlag !== -1 &&
        this.params.countDownTime > 0 &&
        !this.isAlreadySubmit
        ? true
        : false;
    },
    isShowProblemSolved() {
      let arr = [2, 3, 8, 4, 9];
      const { category, reviewContent } = this.params.bundle[this.index];

      // 未收题不显示题解
      if (!this.everUnPublished) return false;
      if (arr.includes(category) && reviewContent) return true;
      return false;
    },
    newSubmitBtn() {
      return this.isShowOverlay && this.params.bundle.length - 1 === this.index;
    },
  },

  methods: {
    // 退出编辑器（切题、返回、beforeunload）
    viewEditorDuration() {
      const pub = generateEditorPub(this.params.bundle[this.index].category);
      xesView('view_xiaohou_jingsai_editor_duration', {
        ...pub,
        scene: '竞赛平台',
        cp_id: this.competitionId.toString(),
        question_id: this.params.bundle[this.index].practiceId,
        duration_time: `${Date.now() - this.enterTime}`,
      });
      this.$nextTick(() => (this.enterTime = Date.now()));
    },

    // 题解弹窗
    showProblemSolved() {
      this.isShowProblemSolvedDialog = true;
    },

    showDialog(info) {
      this.modal = {
        title: '提交成功',
        label: '竞赛本部分全部题目已成功提交',
        btnLabel: '返回',
      };
      if (info) this.modal = info;
      this.isNeedDialog = true;
      this.isClearTimer = true;
    },
    handleHandBack() {
      clearInterval(this.timer);
      this.isHandSubmit = false;
      this.count = 5;
      this.isHandDialog = false;
      this.isShowDiagnosisDialog = false;
    },
    async handleHandSubmit(diagnosisStatus = 1) {
      try {
        // 避免诊断多次提交
        if (this.params.submited && this.compType === 3) {
          this.isShowDiagnosisDialog = true;
          this.diagnosisDialogStatus = diagnosisStatus;
          return;
        }

        // 常规竞赛交卷
        let http = saveProject;
        // 诊断交卷
        if (this.compType === 3) http = submitDiagnosis;
        const { status } = await http({
          bundleId: this.params.bundleId,
          competitionId: this.competitionId,
        });
        this.isHandDialog = false;
        if (this.compType !== 3) {
          this.showDialog();
          if (status === 200) {
            // 记录试卷提交时间
            recordSubmitTime({
              competitionId: this.competitionId,
              bundleId: this.params.bundleId,
              type: 1,
            });
            this.destorySse();
          }
        } else {
          this.isShowDiagnosisDialog = true;
          this.diagnosisDialogStatus = diagnosisStatus;
          this.params.submited = true; // 避免倒计时和手动提交重复
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    },
    getCode() {
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        if (this.count > 1) {
          this.count--;
          this.isHandSubmit = false;
        } else {
          clearInterval(this.timer);
          this.isHandSubmit = true;
          this.count = 5;
        }
      }, 1000);
    },
    handleSubmit() {
      this.getCode();
      this.handleDeliver();
      this.isHandDialog = true;
      this.isActiveSubmission = true;
      // swal
      //   .swal({
      //     title: `提交后本部分题目将无法修改，确定提交全部题目吗？`,
      //     icon: 'warning',
      //     buttons: ['返回', this.handBtnText],
      //   })

      // .then(async (willSubmit) => {
      //   if (willSubmit) {
      //     try {
      //       this.handleDeliver();
      //       await saveProject({
      //         bundleId: this.params.bundleId,
      //       });
      //       this.showDialog();
      //     } catch ({ data }) {
      //       swal.error(data.message);
      //     }
      //   }
      // });
    },
    handleDeliver() {
      if (window.frames && window.frames.length > 0) {
        const obj = JSON.stringify({
          type: 'XH_INVOKE_SAVE_PROJECT',
          payload: {
            showMessage: false,
          },
        });
        window.frames[0].postMessage(obj, '*');
      }
    },
    async handlePaperEnsure(evt) {
      const answer = JSON.stringify(evt.obj[0].data);
      const isRight = flatMapDeep(evt.obj[0].result).every(
        (item) => item === 1
      );
      try {
        await updatePaperAnswer({
          answer,
          bundleId: this.params.bundleId,
          questionId: evt.questionId,
          type: evt.type,
          ratio: evt.ratio,
          // result: isRight === true ? 1 : 2,
          resultStr: window.btoa(
            `${isRight === true ? 1 : 2}_${new Date().getTime()}`
          ),
          practiceId: this.params.bundle[this.index].practiceId,
        });

        await this.updateStatus();
        if (!this.everUnPublished) {
          this.handlePaperNext();
        }
      } catch ({ data }) {
        errorHandler(data);
      }
    },
    handlePaperNext() {
      if (this.index < this.params.bundle.length - 1) {
        this.index += 1;
      } else {
        this.$message.showMessage({ info: '已经是最后一题啦！' });
      }
    },
    handleCppPage(e) {
      if (e.pageStatus === 'homepage') {
        this.isShowOverlay = true;
      } else if (e.pageStatus === 'subpage') {
        this.isShowOverlay = false;
      }
    },
    async handleCppFinish() {
      await this.handleUpdate();
      if (this.index < this.params.bundle.length - 1) {
        this.index += 1;
      }
    },
    selectIndex(e) {
      this.index = e.index;
    },
    genBackCSS() {
      const arr = ['eachendcompiler--back', 'fontweight500'];
      const { category } = this.params.bundle[this.index];
      if ([1].includes(category)) arr.push('eachendcompiler--back-cm');
      if ([2, 7].includes(category)) arr.push('eachendcompiler--back-scratch');
      if ([3, 4, 6, 5, 8, 9].includes(category))
        arr.push('eachendcompiler--back-cpp');
      return arr;
    },
    genHandCSS() {
      const arr = ['eachendcompiler--back', 'fontweight500'];
      const { category } = this.params.bundle[this.index];
      if ([1].includes(category)) arr.push('eachendcompiler--hand-cm');
      if ([2, 7].includes(category)) arr.push('eachendcompiler--hand-scratch');
      if ([3, 4, 6, 5, 8, 9].includes(category))
        arr.push('eachendcompiler--hand-cpp');
      return arr;
    },
    handleBack() {
      this.handleDirectBack();
      this.viewEditorDuration();
    },
    handleDirectBack() {
      this.$router.push(this.back);
      // loading.hide();
      this.$vmLoading.hide();
    },
    // handleDeliver() {
    //   if (window.frames && window.frames.length > 0) {
    //     const { protocol, host } = window.location;
    //     const targetOrigin = `${protocol}//${host}`;
    //     const obj = JSON.stringify({
    //       type: 'XH_INVOKE_SAVE_PROJECT',
    //       payload: {
    //         showMessage: false,
    //       },
    //     });
    //     window.frames[0].postMessage(obj, targetOrigin);
    //   }
    // },
    handleLoaded() {
      this.isShowOverlay = true;
    },
    async handleUpdate() {
      // if (e && e.result === 0) {
      //   this.params.bundle[this.index].correct = false;
      //   this.params.bundle[this.index].finish = true;
      // } else if (e && e.result === 1) {
      //   this.params.bundle[this.index].correct = true;
      //   this.params.bundle[this.index].finish = true;
      // } else {
      //   try {
      //     await this.updateStatus();
      //   } catch ({ data }) {
      //     errorHandler(data)
      //   }
      // }
      try {
        await this.updateStatus();
      } catch ({ data }) {
        errorHandler(data);
      }
    },
    async updateStatus() {
      const { data } = await updateBundle({
        practiceId: this.params.bundle[this.index].practiceId,
        category: this.params.bundle[this.index].category,
        projectId: this.params.bundle[this.index].projectId,
        bundleId: this.params.bundleId,
      });
      this.params.bundle[this.index].correct = data.correct;
      this.params.bundle[this.index].finish = data.finish;
      let theDifference = 0;
      if (this.params.bundle[this.index].score) {
        const score =
          this.params.bundle[this.index].score === '-'
            ? '0'
            : this.params.bundle[this.index].score;
        theDifference = data.score - score;
      }
      this.params.totalScore =
        Number(this.params.totalScore) + Number(theDifference);
      this.params.bundle[this.index].score = data.score;
      // 竞赛 => 每完成一道题保存一下
      this.handleDeliver();
    },
    async handleChoiceEnsure(e) {
      try {
        await updateStudentAnswer({
          answerId: e.answerId,
          chooseAnswer: e.chooseAnswer,
          // isCorrect: e.isCorrect,
          isCorrectStr: window.btoa(`${e.isCorrect}_${new Date().getTime()}`),
          questionId: e.questionId,
          bundleId: this.params.bundleId,
        });
        await this.updateStatus();
        if (this.everUnPublished) {
          this.handleChoiceFinish();
        }
      } catch ({ data }) {
        errorHandler(data);
      }
    },
    handleChoiceFinish() {
      if (this.index < this.params.bundle.length - 1) {
        this.index += 1;
      } else if (this.index === this.params.bundle.length - 1) {
        this.$message.showMessage({ info: '已经是最后一题啦！' });
        // swal.swal({
        //   title: '提示',
        //   text: '已经是最后一题了！',
        //   icon: 'info',
        //   buttons: ['确定'],
        // });
      }
    },
    // async handleCmRun(e) {
    //   try {
    //     this.isShowReel = false;
    //     await saveCMStars(e);
    //   } catch ({ data }) {
    //     swal.error(data.message);
    //   }
    // },
    async handleCmReport(e) {
      try {
        this.isShowReel = false;
        await saveCMUrl(e);
      } catch ({ data }) {
        errorHandler(data);
      }
    },
    async handleCmFinish() {
      try {
        this.isShowReel = true;
        // await saveCMUrl(e);
        await this.updateStatus();
        if (this.index < this.params.bundle.length - 1) {
          this.index += 1;
        } else {
          this.isCmLast = true;
          // this.isShowDialog = true;
        }
      } catch ({ data }) {
        errorHandler(data);
      }
    },
    handleCmRetry() {
      this.isShowReel = true;
    },

    // 猴博士相关
    async initHbsData(params) {
      const { bundle: bundleList, courseId, bundleId, lessonId } = params;
      const { category, projectId, practiceId } = bundleList[this.index];
      this.hbsParams = Object.assign(
        {},
        {
          compilerType: category,
          projectId,
          courseId,
          bundleId,
          lessonId,
          practiceId,
        }
      );
    },

    handleHbsData(val) {
      Promise.resolve()
        .then(() => {
          this.hbsDataloaded = false;
          this.isPythonOnline = false;
        })
        .then(() => {
          this.initHbsData(val);
        })
        .then(() => {
          setTimeout(() => {
            this.hbsDataloaded = !this.cppCategoryList.includes(
              val.bundle[this.index].category
            ) && !this.notShowHBSCtype.includes(
              val.bundle[this.index].pythonType
            );
            this.isPythonOnline =
              this.params.bundle[this.index].pythonType === 12;
          }, 500);
        });
    },
    modifyTitle() {
      this.$refs.modifysa.showQuit();
    },
    sseSetUp() {
      // 创建eventsource
      this.xeventsource = new XEventSource(
        `${process.env.VUE_APP_URL}/api/competition/sse/competition/end/${this.params.bundleId}/${this.params.timingType}?token=${this.params.token}`
      );
      this.xeventsource.on('open', () => {
        this.sseReconnect();
      });
      this.xeventsource.on('message', (resp) => {
        try {
          this.sseReconnect();
          let competitionEnd = 0;
          const data = JSON.parse(resp.data);
          if (typeof data === 'object') {
            competitionEnd = data.competitionEnd;
            if (competitionEnd === 0) {
              this.params.countDownTime = data.countDownTime;
            }
          } else {
            competitionEnd = data;
          }
          if (competitionEnd === 1) {
            if (this.compType !== 3 && !this.everUnPublished) {
              this.isHandDialog = true;
              this.isActiveSubmission = false;
              // 记录提交时间
              recordSubmitTime({
                competitionId: this.competitionId,
                bundleId: this.params.bundleId,
                type: 2,
              });
            } else {
              this.isShowDiagnosisDialog = true;
              this.handleHandSubmit(2);
            }
            this.destorySse();
            this.handleDeliver();
            this.$vmLoading.hide();
          }
        } catch (err) {
          // console.log(err);
        }
      });
      this.xeventsource.on('error', () => {
        this.sseReconnect();
      });
    },
    sseReconnect() {
      this.sseReconnectTimer && clearTimeout(this.sseReconnectTimer);
      this.sseReconnectTimer = setTimeout(() => {
        this.destorySse();
        this.sseSetUp();
      }, 15000);
    },
    destorySse() {
      this.sseReconnectTimer && clearTimeout(this.sseReconnectTimer);
      if (this.xeventsource && this.xeventsource.destroy) {
        this.xeventsource.destroy();
      }
    },
  },

  async created() {
    const { bundleId, back } = this.$route.query;
    this.back = back;
    // let Submited = JSON.parse(submited)
    // this.isNeedSubmit = !Submited
    // this.isNeedDialog = Submited
    // Submited && this.showDialog();
    try {
      // loading.show();
      const { data } = await getSubject({ bundleId });
      if (!data) return;

      this.params = {
        bundleId,
        firstOpenTime: Number(data.firstOpenTime),
        countDownTime: data.countDownTime,
        timingType: data.timingType,
        bundle: data.practices,
        lessonId: data.lessonId,
        practiceType: data.bundleTag,
        canLook: data.canLook,
        canSave: data.canSave,
        canSubmit: data.canSubmit,
        allowCommit: data.allowCommit,
        projectType: data.projectType,
        handleIndex: data.title,
        competitionEnd: data.competitionEnd,
        bundleExamStatus: data.bundleExamStatus,
        timingFlag: data.timingFlag,
        totalScore: data.totalScore,
        moduleId: data.moduleId,
        submited: data.submited,
      };
      // 参数修正
      this.params.token = '';
      if (this.isSerial && this.loginType !== 1) {
        // 撇开内部系列赛
        this.params.token = JSON.parse(
          localStorage.getItem(this.xilieTokenKey)
        ).token;
      } else {
        this.params.token =
          JSON.parse(localStorage.getItem(this.tokenKey)).token ||
          JSON.parse(localStorage.getItem(this.tokenKey)).accessToken;
      }
      this.params.role = '1';
      this.params.fr = 'ts';
      this.isNeedSubmit = !data.submited;
      // 如果收题后再次进入则不显示交卷
      // 诊断情况只判断是否提交过，未提交就可以提交
      if (data.everUnPublished && this.compType !== 3) {
        this.isNeedSubmit = false;
      }
      // this.isNeedDialog = data.submited
      // data.submited && this.showDialog();
      this.allowEnterAgain = data.allowEnterAgain;
      this.everUnPublished = data.everUnPublished;

      // 诊断只要提交试卷，直接展示诊断结果
      if (this.compType === 3 && data.submited) {
        this.isShowDiagnosisDialog = true;
        this.diagnosisDialogStatus = 1;
        this.isClearTimer = true;
        this.$vmLoading.hide();
        return;
      }

      if (!data.everUnPublished && data.submited) {
        this.isHandDialog = true;
        this.isClearTimer = true;
        this.isAlreadySubmit = true;
        this.$vmLoading.hide();
      } else {
        recordStartAnswerTime({
          competitionId: this.competitionId,
          bundleId: this.params.bundleId,
        });
      }
    } catch ({ data }) {
      // loading.hide();
      this.$vmLoading.hide();
      errorHandler(data);
    }

    // 竞赛 & 未收题 => 创建轮训链接
    this.isNeedCorrect = true;
    this.isNeedPre = true;
    try {
      const res = await getCompetitionStatus({
        bundleId: this.params.bundleId,
        timingType: this.params.timingType,
      });
      this.isNeedPre = false;
      if (res.data === 0 && !this.isAlreadySubmit) {
        const r = +new Date() % 10;
        setTimeout(() => {
          this.sseSetUp();
        }, r * 1000);
      } else {
        // this.modal.title = '题目收取成功';
        // this.modal.label = '竞赛时间结束，已提交最新答题结果！';
        // this.modal.btnLabel = '确定';
        // this.isNeedDialog = true;
        if (this.everUnPublished && this.allowEnterAgain === 1) {
          this.isHandDialog = false;
          this.isShowDiagnosisDialog = false;
        } else {
          if (this.compType !== 3) {
            this.isHandDialog = true;
          } else {
            this.isShowDiagnosisDialog = true;
            this.handleHandSubmit();
          }
        }
        this.isClearTimer = true;
        this.isActiveSubmission = false;
        this.$vmLoading.hide();
      }
    } catch ({ data }) {
      errorHandler(data);
    }
    window.addEventListener('beforeunload', this.viewEditorDuration, false);
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.viewEditorDuration, false);
    this.destorySse();
  },
  watch: {
    index() {
      this.handleHbsData(this.params);
      this.viewEditorDuration();
    },
    params: {
      handler(newVal) {
        this.initHbsData(newVal);
        this.hbsDataloaded = !this.cppCategoryList.includes(
          this.params.bundle[this.index].category
        ) && !this.notShowHBSCtype.includes(
          this.params.bundle[this.index].pythonType
        );
        this.isPythonOnline = this.params.bundle[this.index].pythonType === 12;
      },
      deep: true,
    },
  },
};
</script>

<style
  scoped
  lang="less"
  rel="stylesheet/less"
  src="@/assets/less/compiler/eachend.less"
></style>
<style lang="less">
.swal-title {
  font-size: 24px;
}
.hand {
  .header {
    text-align: center;
    margin-top: 25px;
    font-size: 24px;
    color: #333;
    font-weight: 500;
  }
  .eachendcompiler--dialog {
    height: 302px;
  }
  .hand_btn {
    display: flex;
    justify-content: center;
    margin-top: 40px;
    .eachendcompiler--dialog-btn {
      margin: 0 10px;
      width: 140px;
      &.back {
        background: #fcebcb;
        color: #6b4c2e;
      }
      &.submit {
        background: #68953c;
      }
      &.down_count {
        background: #bebebe;
      }
    }
  }
  .eachendcompiler--dialog-txt {
    h5 {
      color: #333;
      width: 318px;
      margin: 0 auto;
    }
  }
  .eachendcompiler--dialog-icon {
    width: 50px;
    height: 50px;
    margin-top: 32px;
    background: url('~@/assets/mark_icon.png') no-repeat center;
    background-size: 50px 50px;
  }
}
</style>
